import BaseWrapper from 'creative-ui/oktaComponents/BaseWrapper';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useTransactionLocale } from '@/hooks/useTranslationLocale';
import { trackPageView } from '@/lib/tagging';
import { ResetPasswordRequestForm } from '@/screens/reset-password-request/components/ResetPasswordRequestForm';
import { getLoginRedirectUrl } from '@/utils/helpers/environment';

// Main Reset Password Request Screen
function ResetPasswordRequestScreen() {
  const { t } = useTranslation('resetPasswordRequest');
  const locale = useTransactionLocale();

  useEffect(() => {
    trackPageView('recovery/email');
  }, []);

  const title = t('resetPasswordForm.title');

  document.title = t('pageTitle');

  const handleBackToLogin = () => {
    window.location.href = getLoginRedirectUrl(locale);
  };

  return (
    <BaseWrapper title={title} backCtaProps={{ onClick: handleBackToLogin }}>
      <ResetPasswordRequestForm />
    </BaseWrapper>
  );
}

export default ResetPasswordRequestScreen;
